import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Entrega } from '../shared/entrega.model';

export interface EntregaDialogData {
  entrega?: Entrega | null;
}

@Component({
  selector: 'app-entrega-dialog',
  templateUrl: './entrega-dialog.component.html',
  styleUrls: ['./entrega-dialog.component.css'],
})
export class EntregaDialogComponent implements OnInit {

  entregaForm: FormGroup;
  maximizado: boolean = false;
  entregaId: number | null = null;

  constructor(
    public dialogRef: MatDialogRef<EntregaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EntregaDialogData,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    const entrega = this.data?.entrega || new Entrega();

    this.entregaId = entrega.entregaId ?? null;

    this.entregaForm = new FormGroup({
      localEntrega: new FormControl(entrega.localEntrega || '', [Validators.required]),
      nomeDestinatario: new FormControl(entrega.nomeDestinatario || '', [Validators.required]),
      cpfDestinatario: new FormControl(entrega.cpfDestinatario || ''),
      setorDestinatario: new FormControl(entrega.setorDestinatario || ''),
      dataEntrega: new FormControl(entrega.dataEntrega ? new Date(entrega.dataEntrega as any) : null, [Validators.required]),
    });
  }

  get tituloDialog(): string {
    return this.entregaId !== null && this.entregaId !== undefined
      ? `Forma de Entrega ${this.entregaId}`
      : 'Forma de Entrega';
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    if (this.entregaForm.invalid) {
      this.entregaForm.markAllAsTouched();
      return;
    }

    const dataEntregaValue = this.entregaForm.get('dataEntrega')?.value;
    const entrega: Entrega = {
      entregaId: this.entregaId ?? null,
      localEntrega: this.entregaForm.get('localEntrega')?.value || '',
      nomeDestinatario: this.entregaForm.get('nomeDestinatario')?.value || '',
      cpfDestinatario: this.entregaForm.get('cpfDestinatario')?.value || '',
      setorDestinatario: this.entregaForm.get('setorDestinatario')?.value || '',
      dataEntrega: dataEntregaValue ? new Date(dataEntregaValue) : null,
    };

    this.snackBar.open(
      'Entrega editada com sucesso, clique em Salvar Fatura para salvar as alterações realizadas',
      'Fechar',
      { duration: 5000 }
    );

    this.dialogRef.close(entrega);
  }

  onExcluirEntrega(): void {
    this.entregaForm.reset({
      localEntrega: '',
      nomeDestinatario: '',
      cpfDestinatario: '',
      setorDestinatario: '',
      dataEntrega: null,
    });
    this.entregaId = null;

    this.snackBar.open(
      'Entrega excluída com sucesso, clique em Salvar Fatura para salvar as alterações realizadas',
      'Fechar',
      { duration: 5000 }
    );

    // Sentinel para o componente pai zerar a entrega do item/subitem.
    this.dialogRef.close({ excluir: true });
  }

  fecharDialog(): void {
    this.dialogRef.close();
  }

  maximizarDialog(): void {
    this.dialogRef.updateSize('100%', '100%');
    this.maximizado = true;
  }

  restaurarDialog(): void {
    const innerWidth = window.innerWidth;

    if (innerWidth < 1024) {
      this.dialogRef.updateSize('95vw', 'auto');
    } else {
      this.dialogRef.updateSize('900px', 'auto');
    }

    this.maximizado = false;
  }
}
